import { State } from '../../reducers';
import { createSelector } from '@ngrx/store';
import MapState, { initialState as mapInitialState } from './map.reducer';

export const getMapState = (state: State) => state.map ?? mapInitialState;

export const selectCurrentExtent = createSelector(getMapState, (state: MapState) => state.currentExtent);

export const selectMapQuery = createSelector(getMapState, (state: MapState) => state.mapQuery);
